"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealMilkLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealMilkLinear = function MealMilkLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.281 14.967l5.053 5.054a4 4 0 010 5.657l-5.656 5.656a4 4 0 01-5.657 0l-5.054-5.053 1.414-1.414 2.64 2.639 8.485-8.486-2.639-2.639 1.414-1.414zm2.639 5.467l-8.486 8.486 1.001 1a2 2 0 002.719.102l.11-.102 5.656-5.657a2 2 0 00.102-2.719l-.102-.109-1-1zM15.07 9.415l1.656 1.655a6.003 6.003 0 016.679 1.028l2.875 2.87-1.414 1.414-2.885-2.876a4 4 0 00-5.352.014l-.145.138-2.121-2.121-2.829 2.828 2.122 2.121a4 4 0 00-.138 5.512l2.862 2.87-1.414 1.414-2.91-2.919a6.003 6.003 0 01-.987-6.636l-1.656-1.655a1 1 0 010-1.414l4.243-4.243a1 1 0 011.414 0zm-2.12-2.122a1 1 0 010 1.414L8.707 12.95a1 1 0 11-1.414-1.414l4.243-4.243a1 1 0 011.414 0z",
    fill: "#95A0B3"
  }));
};

exports.MealMilkLinear = MealMilkLinear;
var _default = MealMilkLinear;
exports.default = _default;